import React from 'react';
import { Chip } from '@mui/material';

const Status = ({ value }) => {
  let color, label;
  let variant = 'outlined';

  switch (value) {
    case 'Active':
      color = 'success';
      label = 'Active';
      break;
    case true:
      color = 'success';
      label = 'Active';
      break;
    case 'Received':
      color = 'success';
      label = 'Received';
      break;
    case false:
      color = 'error';
      label = 'Disabled';
      break;
    case 'Pending':
      color = 'warning';
      label = 'Pending';
      break;
    case 'Ready':
      color = 'warning';
      label = 'Ready';
      variant = 'filled';
      break;
    case 'Sent':
      color = '';
      label = 'Sent';
      break;
    case 'Requested':
      color = 'info';
      label = 'Requested';
      break;
    default:
      color = 'default';
      label = value || 'Unknown';
  }

  return (
    <Chip
      label={label}
      variant={variant}
      color={color}
      style={{ fontWeight: 'bold' }}
    />
  );
};

export default Status;